// extracted by mini-css-extract-plugin
module.exports = {"hero":"Layout_hero__2ETbc"};